// src/components/RouteLoadingFallback.jsx
import React from "react";

/**
 * Fallback ringan ketika chunk halaman sedang dimuat.
 * Tidak bergantung pada CSS page tertentu agar aman dipakai oleh semua route.
 */
export default function RouteLoadingFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: "#f8fafc",
        color: "#334155",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          aria-hidden="true"
          style={{
            width: 34,
            height: 34,
            margin: "0 auto 12px",
            border: "3px solid #cbd5e1",
            borderTopColor: "#0f766e",
            borderRadius: "50%",
            animation: "kbkk-route-spin .8s linear infinite",
          }}
        />
        <div style={{ fontSize: 14, fontWeight: 600 }}>Memuat halaman…</div>
        <style>{`@keyframes kbkk-route-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
